import './app.scss';

BX.Vue.component('bx-client-support',
    {
        data: function () {
            return {
                title: this.$parent.NAME,
                tiles: this.$parent.ITEMS,
            }
        },
        computed: {
            supportCardMore: () => BX.msg('A_CLIENT_SUPPORT_BTN'),
        },
        template: ` 
          <div class="support">
              <div class="container grid-2024">
                <h1 class="support__title h2 g-col-full g-start-lg-4 g-col-lg-6">{{title}}</h1>
                <div class="support__list">
                  <div class="grid-2024">
                    <div v-for="card in tiles" class="support-card g-col-full g-col-lg-6" :class="'-' + card.CODE" :key="card.ID" >
                    <div class="support-card__header">
                        <p class="support-card__title t1">{{card.NAME}}</p>
                        <p class="support-card__intro t2" v-if="card['DESCRIPTION_ADDITIONAL'].length">{{card['DESCRIPTION_ADDITIONAL']}}</p>
<!--                        <p v-if="card.description?.length" class="support-card__description">{{card.description}}</p>-->
                        <a class="support-card__button button-2024 -m -outline" :href="card['SECTION_PAGE_URL']">{{supportCardMore}}</a>
                    </div>
                    <div class="support-card__body">
                      <template v-if="Array.isArray(card.ITEMS[0])">
                        <div class="support-card__row">
                          <div v-for="col in card.ITEMS" class="support-card__col">
                            <ul class="support-card__list">
                              <li v-for="item in col" :key="item.ID" class="support-card__list-item">
                                <a class="support-card__list-link" :href="item.SECTION_PAGE_URL">{{item.NAME}}</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <ul class="support-card__list">
                          <li v-for="item in card.ITEMS" :key="item.ID" class="support-card__list-item">
                            <a class="support-card__list-link" :href="item.SECTION_PAGE_URL">{{item.NAME}}</a>
                          </li>
                        </ul>
                      </template>
                    </div>
                  </div>
                  </div>
                </div>
              </div>
          </div>
        `
    }
);